import React from 'react'

import classes from './spinner.css'

const spinner =(props)=>(
    <div className ={classes.loader} >Loading...</div>
);

export default spinner;


// WEBPACK FOOTER //
// ./src/components/UI/Spinner/spinner.js